import React from "react";
import { motion } from "framer-motion";
import { Hammer, Users, Wrench } from "lucide-react";
import { reveal } from "./constants";

export function About() {
  return (
    <section className="relative py-8 sm:py-12 bg-[#0A0A0A] text-[#FFFFFF] overflow-hidden grain" data-testid="about-section">
      <div className="relative max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <motion.div {...reveal}>
          <div className="text-xs font-bold uppercase tracking-[0.22em] text-[#C9C9C9] mb-4">
            About Mike
          </div>
          <blockquote className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-[1.15]">
            "I treat every house like it belongs to a neighbor — because around here,
            it usually does. Fair price, clean work, and I'll clean up after myself."
          </blockquote>
          <div className="mt-8 flex items-center justify-center gap-3">
            <div className="w-10 h-px bg-[#C9C9C9]" />
            <span className="text-sm font-semibold uppercase tracking-[0.22em] text-[#C9C9C9]">
              Mike Harrison · The Glenwood Gutter Guy
            </span>
            <div className="w-10 h-px bg-[#C9C9C9]" />
          </div>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-6">
          {[
            { icon: Hammer, title: "Hands-on", body: "Every job done personally — no crews, no rushing." },
            { icon: Users, title: "Neighborly", body: "Friendly service for friends, family, and first-timers." },
            { icon: Wrench, title: "No upsell", body: "Flat rates. If you don't need it, I won't sell it." },
          ].map(({ icon: Icon, title, body }) => (
            <motion.div
              key={title}
              {...reveal}
              className="bg-[#0F0F0F] border border-[#1F1F1F] p-6 rounded-sm text-left"
            >
              <Icon className="w-6 h-6 text-[#5FBE1F]" />
              <div className="mt-4 font-display font-bold text-xl">{title}</div>
              <p className="mt-2 text-sm text-[#C9C9C9] leading-relaxed">{body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
